import { Button, Slider, LoadingIndicator } from '@components';
import { Field, Formik } from 'formik';
import React, { useState } from 'react';
import { currency } from '@utils';
import { format } from 'date-fns';
import { resgateParcialPercentuaisSchema } from '../../../../common/schemas/beneficios/resgate-parcial';
import { ResgateParcialService } from '../../../../common/services/resgate-parcial';
import { NotaExplicativa } from '../components/NotaExplicativa';
import {
  dadosSimulacaoResgatePDF,
  gerarDadosSimulacao,
} from '../utils/resgate-parcial';

export const StepsResgateSimulacao = ({
  setInfoModalIsOpen,
  setInfoModal,
  setViewTerms,
  dadosPrevidenciarios,
  dadosEmprestimo,
  dadosPessoais,
}) => {
  const [loading, setLoading] = useState(false);
  const [steps, setSteps] = useState({ one: true, two: false });
  const [viewSteps, setViewSteps] = useState({ one: true, two: false });
  const [simulateParams, setSimulateParams] = useState({
    contaIndividual: 0,
    contaAdicional: 0,
    contaEventual: 0,
    contaPortabilidadeAberta: 0,
  });
  const [simulateData, setSimulateData] = useState({});

  function handleSteps(value) {
    const changedValues = {
      ...!steps,
      [value]: !steps[value],
    };

    const changedViewSteps = {
      ...viewSteps,
      [value]: true,
    };

    setSteps(changedValues);
    setViewSteps(changedViewSteps);
  }

  const handleSimulateValues = (values) => {
    setLoading(true);
    const service = new ResgateParcialService();
    service
      .ObterDadosPrevidenciariosResgate(
        dadosPessoais.matricula,
        dadosPessoais.plano,
        values.contaIndividual,
        values.contaAdicional,
        values.contaEventual,
        values.contaPortabilidadeAberta
      )
      .then((res) => {
        setSimulateData(
          gerarDadosSimulacao(
            res,
            dadosPrevidenciarios,
            dadosPessoais,
            dadosEmprestimo
          )
        );

        setLoading(false);
        handleSteps('two');
      });
  };

  const gerarSimulacaoResgatePDF = () => {
    const service = new ResgateParcialService();
    const pdfData = dadosSimulacaoResgatePDF(
      {
        params: simulateParams,
        result: simulateData,
        title:
          simulateData.RegimeDefinitivo === 'SIM'
            ? simulateData.RegimeTributacao
            : '',
      },
      dadosEmprestimo,
      dadosPrevidenciarios
    );

    if (simulateData.RegimeDefinitivo === 'SIM') {
      if (simulateData.RegimeTributacao === 'REGRESSIVO') {
        delete pdfData.Progressivo;
      } else {
        delete pdfData.Regressivo;
      }
    }

    service
      .GerarSimulacaoResgateParcialPDF({
        ...pdfData,
        matricula: dadosPessoais.matricula,
        nome: dadosPessoais.nome,
        token: dadosPessoais.token,
        dtGeracao: format(new Date(), 'dd/MM/yyyy às HH:mm'),
      })
      .then((base64) => {
        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${base64}`;
        link.download = `Simulação de resgate parcial - ${dadosPessoais.matricula}.PDF`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };

  return (
    <>
      <div id="step-01" className={`tbstep ${!steps.one && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.one && 'tbstepNumber-focused'} ${
              viewSteps.one && !steps.one && 'tbstepNumber-filled'
            }`}
          >
            1
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Simulador</strong>
            </h2>
            {steps.one && (
              <p>Escolha os percentuais para realizar a simulação.</p>
            )}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.one && !steps.one && (
            <button className="tbviewStep" onClick={() => handleSteps('one')}>
              Editar
            </button>
          )}
          {!loading ? (
            <div>
              {steps.one && (
                <>
                  <div className="tbOptionLabel">
                    <p>
                      Valores disponíveis em{' '}
                      {format(
                        new Date(dadosPrevidenciarios.DataReferencia),
                        'MM/yyyy'
                      )}
                    </p>
                  </div>

                  <Formik
                    initialValues={simulateParams}
                    validationSchema={resgateParcialPercentuaisSchema}
                    onSubmit={(values) => {
                      setSimulateParams(values);
                      handleSimulateValues(values);
                    }}
                  >
                    {({ handleSubmit, isValid, values }) => {
                      return (
                        <form onSubmit={handleSubmit}>
                          <div className="contentOption">
                            <div className="contentHeader">
                              <h3 className="content-headerTitle">
                                Conta Individual
                              </h3>
                              <h3 className="content-headerTitle">
                                {currency(dadosPrevidenciarios.ValorIndividual)}
                              </h3>
                            </div>
                            <NotaExplicativa
                              aliquotaRegressiva={
                                dadosPrevidenciarios.AliquotaIndividual
                              }
                              percentualRetirada={20}
                              regimeTributacaoDefinitivo={
                                dadosPrevidenciarios.RegimeDefinitivo === 'SIM'
                                  ? dadosPrevidenciarios.RegimeTributacao
                                  : ''
                              }
                              conta="individual"
                            />
                            <Field
                              minValue={0}
                              maxValue={20}
                              name="contaIndividual"
                              component={Slider}
                              label="Qual percentual você deseja retirar?"
                            />
                            <ValorLiberacao
                              valor={
                                (dadosPrevidenciarios.ValorIndividual *
                                  (values?.contaIndividual || 0)) /
                                100
                              }
                            />
                          </div>
                          {!!dadosPrevidenciarios.ValorAdicional && (
                            <div className="contentOption">
                              <div className="contentHeader">
                                <h3 className="content-headerTitle">
                                  Conta Adicional
                                </h3>
                                <h3 className="content-headerTitle">
                                  {currency(
                                    dadosPrevidenciarios.ValorAdicional
                                  )}
                                </h3>
                              </div>
                              <NotaExplicativa
                                aliquotaRegressiva={
                                  dadosPrevidenciarios.AliquotaAdicional
                                }
                                percentualRetirada={100}
                                regimeTributacaoDefinitivo={
                                  dadosPrevidenciarios.RegimeDefinitivo ===
                                  'SIM'
                                    ? dadosPrevidenciarios.RegimeTributacao
                                    : ''
                                }
                                conta="adicional"
                              />
                              <Field
                                minValue={0}
                                maxValue={100}
                                name="contaAdicional"
                                component={Slider}
                                label="Qual percentual você deseja retirar?"
                              />
                              <ValorLiberacao
                                valor={
                                  (dadosPrevidenciarios.ValorAdicional *
                                    (values?.contaAdicional || 0)) /
                                  100
                                }
                              />
                            </div>
                          )}
                          {!!dadosPrevidenciarios.ValorEventual && (
                            <div className="contentOption">
                              <div className="contentHeader">
                                <h3 className="content-headerTitle">
                                  Conta Eventual
                                </h3>
                                <h3 className="content-headerTitle">
                                  {currency(dadosPrevidenciarios.ValorEventual)}
                                </h3>
                              </div>
                              <NotaExplicativa
                                aliquotaRegressiva={
                                  dadosPrevidenciarios.AliquotaEventual
                                }
                                percentualRetirada={100}
                                regimeTributacaoDefinitivo={
                                  dadosPrevidenciarios.RegimeDefinitivo ===
                                  'SIM'
                                    ? dadosPrevidenciarios.RegimeTributacao
                                    : ''
                                }
                                conta="eventual"
                              />
                              <Field
                                minValue={0}
                                maxValue={100}
                                name="contaEventual"
                                component={Slider}
                                label="Qual percentual você deseja retirar?"
                              />
                              <ValorLiberacao
                                valor={
                                  (dadosPrevidenciarios.ValorEventual *
                                    (values?.contaEventual || 0)) /
                                  100
                                }
                              />
                            </div>
                          )}

                          {!!dadosPrevidenciarios.ValorPortabilidadeAberta && (
                            <div className="contentOption">
                              <div className="contentHeader">
                                <h3 className="content-headerTitle">
                                  Conta Portabilidade Aberta
                                </h3>
                                <h3 className="content-headerTitle">
                                  {currency(
                                    dadosPrevidenciarios.ValorPortabilidadeAberta
                                  )}
                                </h3>
                              </div>
                              <NotaExplicativa
                                aliquotaRegressiva={
                                  dadosPrevidenciarios.AliquotaPortabilidadeAberta
                                }
                                percentualRetirada={100}
                                regimeTributacaoDefinitivo={
                                  dadosPrevidenciarios.RegimeDefinitivo ===
                                  'SIM'
                                    ? dadosPrevidenciarios.RegimeTributacao
                                    : ''
                                }
                                conta="portabilidade aberta"
                              />
                              <Field
                                minValue={0}
                                maxValue={100}
                                name="contaPortabilidadeAberta"
                                component={Slider}
                                label="Qual percentual você deseja retirar?"
                              />
                              <ValorLiberacao
                                valor={
                                  (dadosPrevidenciarios.ValorPortabilidadeAberta *
                                    (values?.contaPortabilidadeAberta || 0)) /
                                  100
                                }
                              />
                            </div>
                          )}

                          <div className="tbbutton gap-4">
                            <Button
                              transparent
                              color="orange"
                              onClick={() => setViewTerms(true)}
                            >
                              Voltar
                            </Button>
                            <Button disabled={!isValid} onClick={handleSubmit}>
                              Continuar
                            </Button>
                          </div>
                        </form>
                      );
                    }}
                  </Formik>
                </>
              )}
            </div>
          ) : (
            <LoadingIndicator />
          )}
        </div>
      </div>

      <div id="step-02" className={`tbstep ${!steps.two && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.two && 'tbstepNumber-focused'} ${
              viewSteps.two && !steps.two && 'tbstepNumber-filled'
            }`}
          >
            2
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Resultado</strong>
            </h2>
            {steps.two && <p>Confira o resultado da simulação.</p>}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.two && !steps.two && (
            <button className="tbviewStep" onClick={() => handleSteps('two')}>
              Visualizar
            </button>
          )}
          {steps.two && (
            <>
              <div className="result-container">
                <div className="result-title">
                  <p>Valor simulado para resgate</p>
                  <p>{currency(simulateData.ValorTotalResgate)}</p>
                </div>
                <div className="tbrow" />
                <span className="result-container-span">
                  Esse valor corresponde a{' '}
                  {simulateData.percentualRetirado?.toFixed(2)}% do seu saldo de
                  conta e será abatido do percentual disponível para retirada de
                  parcela à vista no ato do requerimento de benefício mensal.
                </span>
              </div>

              {(dadosPrevidenciarios.RegimeDefinitivo === 'NÃO' ||
                dadosPrevidenciarios.RegimeTributacao === 'PROGRESSIVO') && (
                <div className="result-container">
                  <div className="result-title">
                    <p>Regime Progressivo</p>
                    <button
                      onClick={() => {
                        setInfoModal({
                          params: simulateParams,
                          result: simulateData,
                          title: 'Progressivo',
                        });
                        setInfoModalIsOpen(true);
                      }}
                    >
                      Detalhar
                    </button>
                  </div>
                  <div className="tbrow" />

                  <div className="result-values">
                    <p>Alíquota imposto de renda</p>
                    <p>15%</p>
                  </div>
                  <div className="result-values">
                    <p>Desconto imposto de renda</p>
                    <p>
                      {currency(-(simulateData.ValorTotalResgate * 15) / 100)}
                    </p>
                  </div>
                  {!!simulateData.descontoEmprestimoProgressivo
                    .descontoTotal && (
                    <div className="result-values">
                      <p>Desconto empréstimo</p>
                      <p>
                        {currency(
                          -simulateData.descontoEmprestimoProgressivo
                            .descontoTotal
                        )}
                      </p>
                    </div>
                  )}

                  <div className="tbrow" />
                  <div className="result-values">
                    <p>Valor previsto para liberação</p>
                    <p className="result-total">
                      {currency(simulateData.valorTotalResgateProgressivo)}
                    </p>
                  </div>
                  {/* <span className="result-text-error">
                    {infosDetails.progressivo.msgConsistencia}
                  </span> */}
                </div>
              )}

              {(dadosPrevidenciarios.RegimeDefinitivo === 'NÃO' ||
                dadosPrevidenciarios.RegimeTributacao === 'REGRESSIVO') && (
                <div className="result-container">
                  <div className="result-title">
                    <p>Regime Regressivo</p>
                    <button
                      onClick={() => {
                        setInfoModal({
                          params: simulateParams,
                          result: simulateData,
                          title: 'Regressivo',
                        });
                        setInfoModalIsOpen(true);
                      }}
                    >
                      Detalhar
                    </button>
                  </div>
                  <div className="tbrow" />
                  <div className="result-values">
                    <p>Alíquota imposto de renda</p>
                    <p>
                      {`${simulateData.AliquotaValorTotalRegressivo.toFixed(
                        2
                      )}%`}
                    </p>
                  </div>
                  <div className="result-values">
                    <p>Desconto imposto de renda</p>
                    <p>
                      {currency(
                        -(
                          simulateData.ValorTotalResgate *
                          simulateData.AliquotaValorTotalRegressivo
                        ) / 100
                      )}
                    </p>
                  </div>
                  {!!simulateData.descontoEmprestimoRegressivo
                    .descontoTotal && (
                    <div className="result-values">
                      <p>Desconto empréstimo</p>
                      <p>
                        {currency(
                          -simulateData.descontoEmprestimoRegressivo
                            .descontoTotal
                        )}
                      </p>
                    </div>
                  )}
                  <div className="tbrow" />
                  <div className="result-values">
                    <p>Valor previsto para liberação</p>
                    <p className="result-total">
                      {currency(simulateData.valorTotalResgateRegressivo)}
                    </p>
                  </div>
                  {/* <span className="result-text-error">
                    {infosDetails.regressivo.msgConsistencia}
                  </span> */}
                </div>
              )}

              <div className="result-terms">
                <h3>Considerações e ressalvas: </h3>
                <ul>
                  <li>
                    Os valores escolhidos para o Resgate Parcial podem sofrer
                    variação devido à rentabilidade apurada. No momento do
                    pagamento, será considerado o percentual do Resgate Parcial
                    definido no ato da solicitação.
                  </li>
                  <li>
                    Para o valor líquido a ser creditado, além da variação da
                    rentabilidade, será aplicado o desconto do imposto de renda.
                    Para o optante do <b>Regime Progressivo</b>, esse desconto é
                    inicial, sendo revisado por ocasião da declaração de ajuste
                    anual. Para o optante do <b>Regime Regressivo</b>, a
                    alíquota será recalculada e definida no momento do pagamento
                    em função do percentual e da conta escolhida para o Resgate
                    Parcial. E ainda, para os participantes com contrato de
                    empréstimo em vigor, o saldo devedor vencido será abatido e
                    o saldo devedor a vencer será proporcionalmente amortizado
                    no Resgate Parcial.
                  </li>
                  <li>
                    A opção pelo Regime de Tributação é <b>IRRETRATÁVEL</b> e
                    será aplicada também no seu benefício de aposentadoria
                    futuro.
                  </li>
                  <li>
                    Os valores referentes ao saldo devedor de empréstimo, quando
                    houver, estão posicionados em{' '}
                    {format(
                      new Date(dadosEmprestimo.DataReferencia),
                      'MM/yyyy'
                    )}{' '}
                    para fins de simulação e serão atualizados no momento do
                    pagamento, podendo, portanto, sofrer alteração.
                  </li>
                </ul>
              </div>

              <div className="tbSimulationButtons">
                {/* <Button
                  transparent
                  color="orange"
                  // disabled={loading}
                  className="max-100"
                  // onClick={() => handleOpenExtrato()}
                >
                  Acessar gráfico de impacto no saldo
                </Button> */}
                <Button
                  transparent
                  color="orange"
                  disabled={!simulateData}
                  className="max-100"
                  onClick={() => {
                    gerarSimulacaoResgatePDF();
                  }}
                >
                  Baixar detalhamento da simulação
                </Button>
                <Button
                  className="max-100"
                  onClick={() => {
                    setSimulateParams({
                      contaIndividual: 0,
                      contaAdicional: 0,
                      contaEventual: 0,
                      contaPortabilidadeAberta: 0,
                    });
                    handleSteps('one');
                  }}
                >
                  Realizar nova simulação
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const ValorLiberacao = ({ valor }) => {
  return (
    <div className="valorLiberacao-container">
      <p className="valorLiberacao-value">{currency(valor)}</p>
      <p className="valorLiberacao-span">Valor previsto para liberação</p>
    </div>
  );
};
